import {
	AfterViewInit,
	Component,
	ElementRef,
	OnInit,
	Renderer2,
} from '@angular/core';
import { DcBaseComponent } from '@datachain/ui-sdk/common';
import { AppModalService } from '@datachain/ui-sdk/components/app-modal';
import { IBreadCrumbEntry } from '@datachain/ui-sdk/components/breadcrumb';
import { Store } from '@ngrx/store';
import { firstValueFrom, takeUntil, tap } from 'rxjs';

import { ResizeProvider } from '../../../core/app-resize-wrapper/resize-provider';
import { goToProjects } from '../../../core/store';
import { DcIcons } from '../../../ui/app-dc.icons';
import { createGroupingTag } from '../../store';
import {
	ConfigPopupComponent,
	GroupingTagConfigPopupData,
} from '../config-popup/config-popup.component';
import { GroupingTagListViewProvider } from './grouping-tag-list-view.provider';

@Component({
	selector: 'app-grouping-tag-list-wrapper',
	template: `
		<app-page>
			<app-page-header>
				<app-breadcrumb [paths]="paths"></app-breadcrumb>
			</app-page-header>

			<app-page-actions>
				<button
					matTooltip="new"
					id="{{ cmpId }}-new-btn"
					i18n-matTooltip="@@general.action.new"
					mat-icon-button
					color="primary"
					(click)="createNew()">
					<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
				</button>
			</app-page-actions>

			<app-page-content>
				<app-grouping-tag-list
					(triggerAddElement)="createNew()"></app-grouping-tag-list>
			</app-page-content>
		</app-page>
	`,
	providers: [GroupingTagListViewProvider],
})
export class GroupingTagListWrapperComponent
	extends DcBaseComponent
	implements OnInit, AfterViewInit
{
	protected readonly DcIcons = DcIcons;
	public paths: Array<IBreadCrumbEntry> = [
		{
			label: $localize`:@@general.projects:`,
			isActive: true,
			callback: (): void => this.store.dispatch(goToProjects()),
		},
		{
			label: $localize`:@@groupingTag.list.title:`,
			isActive: false,
			callback: (): void => {},
		},
	];

	public constructor(
		private readonly store: Store,
		private readonly listViewProvider: GroupingTagListViewProvider,
		private readonly resizeProvider: ResizeProvider,
		private readonly renderer: Renderer2,
		private readonly elemRef: ElementRef,
		private readonly modalService: AppModalService
	) {
		super();
		this.cmpId = 'grouping-tag-list-wrapper';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.triggerInit();
	}

	public override ngAfterViewInit(): void {
		super.ngAfterViewInit();
		setTimeout(() => {
			this.listViewProvider.adjustHeights(this.elemRef, this.renderer);
		}, 500);
	}

	public async createNew(): Promise<void> {
		const modalRef = this.modalService.openPopup<GroupingTagConfigPopupData>(
			ConfigPopupComponent,
			{
				title: $localize`:@@groupingTag.create.modal.title:`,
				subTitle: '',
				id: null,
				label: '',
				color: '',
			},
			{
				disableClose: true,
			}
		);

		const modalConfirmResult = await firstValueFrom(modalRef.afterClosed());

		if (!modalConfirmResult) {
			return;
		}
		this.store.dispatch(
			createGroupingTag({
				color: modalConfirmResult.color,
				label: modalConfirmResult.label,
			})
		);
	}

	private triggerInit(): void {
		this.resizeProvider.data$
			.pipe(
				takeUntil(this.onDestroy$),
				tap(() =>
					this.listViewProvider.adjustHeights(this.elemRef, this.renderer)
				)
			)
			.subscribe();
	}
}
